import {
  QueryDocumentSnapshot,
  DocumentData,
  SnapshotOptions,
  PartialWithFieldValue,
  QuerySnapshot,
} from "firebase/firestore";
import { extractNonUndefined } from "~/lib/utils/objectHelper";
import { Topic, TopicPrDisplayTypeEnum } from "~/models/topic";

export const topicConverter = {
  fromFirestore(
    snapshot: FirebaseFirestore.DocumentSnapshot | QueryDocumentSnapshot,
    options?: SnapshotOptions
  ): Topic {
    const data = options ? snapshot.data(options) : snapshot.data();
    return {
      articleCVAverageLast30Days: data?.articleCVAverageLast30Days || 0,
      articleFbHelpfulAverageLast30Days:
        data?.articleFbHelpfulAverageLast30Days || 0,
      articlePVAverageLast30Days: data?.articlePVAverageLast30Days || 0,
      articleTextCountAverage: data?.articleTextCountAverage || 0,
      callForNewArticleWriting: data?.callForNewArticleWriting || false,
      coverImageUrl: data?.coverImageUrl || null,
      createdUnixTime: data?.createdUnixTime || null,
      description: data?.description || null,
      id: snapshot.id,
      mainImageUrl: data?.mainImageUrl || null,
      makerName: data?.makerName || null,
      name: data?.name || null,
      nameEn: data?.nameEn || null,
      prCategoryNames: data?.prCategoryNames || [],
      prDisplayType: data?.prDisplayType || TopicPrDisplayTypeEnum.none,
      prProductId: data?.prProductId || null,
      prTagName: data?.prTagName || null,
      projectId: data?.projectId || null,
      qaCountWithLocales: data?.qaCountWithLocales || null,
      shortName: data?.shortName || null,
      slug: data?.slug || null,
      twitterTags: data?.twitterTags ?? [],
      updatedUnixTime: data?.updatedUnixTime || null,
    };
  },
  toFirestore(topic: PartialWithFieldValue<Topic>): DocumentData {
    return extractNonUndefined(topic);
  },
};

export function convertTopics({
  topicsSnapshot,
}: {
  topicsSnapshot: QuerySnapshot<Topic>;
}): Topic[] {
  const topics: Topic[] = [];

  topicsSnapshot.forEach((topicDoc: QueryDocumentSnapshot<Topic>) => {
    topics.push(topicDoc.data());
  });

  return topics;
}
